/**
 * Session action types.
 * @enum {string}
 */
export const sessionActionType = {
  SET_INVITE_TOKEN: 'SET_INVITE_TOKEN',
}

/**
 * @typedef {Object} SetInviteTokenActionPayload
 * @property {string} inviteToken
 */

/**
 * @typedef {Object} SetInviteTokenAction
 * @property {sessionActionType} type Action type key
 * @property {SetInviteTokenActionPayload} payload Action payload data
 */

/**
 * Action to set user invite session token.
 *
 * @param {string} inviteToken User invite token
 * @return {SetInviteTokenAction} Action object.
 */
export const setInviteToken = (inviteToken) => {
  return {
    type: sessionActionType.SET_INVITE_TOKEN,
    payload: {
      inviteToken,
    },
  }
}
